<script setup lang="ts">
import type { ModalConfig } from '../modals/modal-types';
import { computed, ref } from 'vue';
import { Dialog, DialogContent } from '../dialog';

const props = defineProps<{ config: ModalConfig }>();

const open = ref(true);
let closed = false;

const widthClass = computed(() => (props.config.options.fitWidth ? 'w-fit max-w-[90vw]' : 'w-full max-w-lg'));

function close(result: unknown = null) {
  if (closed) return;
  closed = true;
  open.value = false;
  props.config.onClose(result);
}
</script>

<template>
  <Dialog :open="open" @update:open="(value) => !value && close()">
    <DialogContent :class="['min-w-96', widthClass]">
      <component :is="config.component" v-bind="config.props as any" @modalClose="close($event)" />
    </DialogContent>
  </Dialog>
</template>
